import request from '@/utils/request'

// ------------------------banner----------------------------

// banner-列表
export function bannerList(data) {
    return request._post('/shop/education.Banner/index', data);
}
// banner-详情
export function bannerDetail(data) {
    return request._post('/shop/education.Banner/detail', data);
}
// banner-添加编辑
export function bannerEdit(data) {
    return request._post('/shop/education.Banner/edit', data);
}
// banner-删除
export function bannerDel(data) {
    return request._post('/shop/education.Banner/del', data);
}

// ------------------------题库----------------------------

// 题库-列表
export function questionList(data) {
    return request._post('/shop/education.Question/index', data);
}
// 题库-详情
export function questionDetail(data) {
    return request._post('/shop/education.Question/detail', data);
}
// 题库-添加编辑
export function questionEdit(data) {
    return request._post('/shop/education.Question/edit', data);
}
// 题库-批量导入
export function batchImport(data) {
    return request._upload('/shop/education.Question/batchImportData', data);
}
// 题库-删除
export function questionDel(data) {
    return request._post('/shop/education.Question/del', data);
}

// ------------------------课程----------------------------
// 课程-列表
export function courseList(data) {
    return request._post('/shop/education.Course/index', data);
}
// 课程-详情
export function courseDetail(data) {
    return request._post('/shop/education.Course/detail', data);
}
// 课程-添加编辑
export function courseEdit(data) {
    return request._post('/shop/education.Course/edit', data);
}
// 课程-删除
export function courseDel(data) {
    return request._post('/shop/education.Course/del', data);
}
// 课程-列表
export function courseLog(data) {
    return request._post('/shop/education.Course/courseLog', data);
}

// ------------------------考试----------------------------
// 考试-列表
export function examList(data) {
    return request._post('/shop/education.Exam/index', data);
}
// 考试-详情
export function examDetail(data) {
    return request._post('/shop/education.Exam/detail', data);
}
// 考试-添加编辑
export function examEdit(data) {
    return request._post('/shop/education.Exam/edit', data);
}
// 考试-删除
export function examDel(data) {
    return request._post('/shop/education.Exam/del', data);
}
// 考试-列表
export function examLog(data) {
    return request._post('/shop/education.Exam/examLog', data);
}
// 考试-列表
export function examLogDetail(data) {
    return request._post('/shop/education.Exam/examLogDetail', data);
}

// ------------------------投票----------------------------
// 投票-列表
export function voteList(data) {
    return request._post('/shop/education.Vote/index', data);
}
// 投票-详情
export function voteDetail(data) {
    return request._post('/shop/education.Vote/detail', data);
}
// 投票-添加编辑
export function voteEdit(data) {
    return request._post('/shop/education.Vote/edit', data);
}
// 投票-审核
export function voteAudit(data) {
    return request._post('/shop/education.Vote/audit', data);
}
// 投票-删除
export function voteDel(data) {
    return request._post('/shop/education.Vote/del', data);
}
// 投票-添加编辑参赛者
export function voteCmpeEdit(data) {
    return request._post('/shop/education.Vote/cmpeEdit', data);
}
// 投票-参赛者列表
export function voteCmpeList(data) {
    return request._post('/shop/education.Vote/cmpeList', data);
}
// 投票-参赛者详情
export function voteCmpeDetail(data) {
    return request._post('/shop/education.Vote/cmpeDetail', data);
}
// 投票-参赛者删除
export function voteCmpeDel(data) {
    return request._post('/shop/education.Vote/cmpeDel', data);
}
// 投票-投票记录
export function voteLog(data) {
    return request._post('/shop/education.Vote/voteLog', data);
}

// ------------------------心愿----------------------------
// 心愿-列表
export function wishList(data) {
    return request._post('/shop/education.Wish/index', data);
}
// 心愿-详情
export function wishDetail(data) {
    return request._post('/shop/education.Wish/detail', data);
}
// 心愿-审核
export function wishAudit(data) {
    return request._post('/shop/education.Wish/audit', data);
}
// 心愿-删除
export function wishDel(data) {
    return request._post('/shop/education.Wish/del', data);
}
// 心愿分类-列表
export function wishCategoryList(data) {
    return request._post('/shop/education.Wish/category', data);
}
// 心愿分类-详情
export function wishCategoryDetail(data) {
    return request._post('/shop/education.Wish/categoryDetail', data);
}
// 心愿分类-编辑
export function wishCategoryEdit(data) {
    return request._post('/shop/education.Wish/categoryEdit', data);
}
// 心愿分类-删除
export function wishCategoryDel(data) {
    return request._post('/shop/education.Wish/categoryDel', data);
}
// 心愿领取记录-列表
export function wishClaim(data) {
    return request._post('/shop/education.Wish/claim', data);
}
// 心愿-提前结束
export function wishClose(data) {
    return request._post('/shop/education.Wish/wishClose', data);
}


// ------------------------单位----------------------------
// 单位-列表
export function companyList(data) {
    return request._post('/shop/education.Company/index', data);
}
// 单位-详情
export function companyDetail(data) {
    return request._post('/shop/education.Company/detail', data);
}
// 单位-添加编辑
export function companyEdit(data) {
    return request._post('/shop/education.Company/edit', data);
}
// 单位-删除
export function companyDel(data) {
    return request._post('/shop/education.Company/del', data);
}
// 单位-管理员列表
export function shopUserList(data) {
    return request._post('/shop/education.Company/shopUserList', data);
}
// 单位-用户列表
export function companyUserList(data) {
    return request._post('/shop/education.Company/userList', data);
}
// 单位-用户详情
export function companyUserDetail(data) {
    return request._post('/shop/education.Company/userDetail', data);
}
// 单位-用户编辑
export function companyUserEdit(data) {
    return request._post('/shop/education.Company/userEdit', data);
}
// 单位-用户删除
export function companyUserDel(data) {
    return request._post('/shop/education.Company/userDel', data);
}
// 部门-批量导入用户
export function depImport(data) {
    return request._upload('/shop/education.Company/deptImportData', data);
}
// 部门-导出用户
export function deptexport(data) {
    return request._upload('/shop/education.Company/deptexport', data);
}

// ------------------------部门----------------------------
// 部门-列表
export function deptList(data) {
    return request._post('/shop/education.Dept/index', data);
}
// 部门-列表Tree
export function deptListTree(data) {
    return request._post('/shop/education.Dept/getListTree', data);
}
// 部门-列表Tree
export function getListChildrenTree(data) {
    return request._post('/shop/education.Dept/getListChildrenTree', data);
}
// 部门-详情
export function deptDetail(data) {
    return request._post('/shop/education.Dept/detail', data);
}
// 部门-添加编辑
export function deptEdit(data) {
    return request._post('/shop/education.Dept/edit', data);
}
// 部门-删除
export function deptDel(data) {
    return request._post('/shop/education.Dept/del', data);
}
// 部门-发送公告
export function sendDeptMsg(data) {
    return request._post('/shop/education.Dept/sendMsg', data);
}

// ------------------------活动----------------------------
// 活动-列表
export function activityList(data) {
    return request._post('/shop/education.Activity/index', data);
}
// 活动-添加编辑
export function activityEdit(data) {
    return request._post('/shop/education.Activity/edit', data);
}
// 活动-详情
export function activityDetail(data) {
    return request._post('/shop/education.Activity/detail', data);
}
// 活动-详情
export function activityDel(data) {
    return request._post('/shop/education.Activity/del', data);
}
// 活动-参与记录
export function enrollList(data) {
    return request._post('/shop/education.Activity/enrollList', data);
}
// 活动-参与详情
export function enrollDetail(data) {
    return request._post('/shop/education.Activity/enrollDetail', data);
}
// 活动-公示内容编辑
export function pubEdit(data) {
    return request._post('/shop/education.Activity/pubEdit', data);
}
// 活动-导出参与用户
export function exportActUser(data) {
    return request._post('/shop/education.Activity/exportActUser', data);
}


// ------------------------VR----------------------------
// vr-vr设置
export function steVr(data) {
    return request._post('/shop/education.Vr/setVr', data);
}
// vr-vr详情
export function vrDetail(data) {
    return request._post('/shop/education.Vr/detail', data);
}

// vr-评论列表
export function commentList(data) {
    return request._post('/shop/education.Vr/commentList', data);
}
// vr-签名列表
export function signList(data) {
    return request._post('/shop/education.Vr/signList', data);
}

// vr-同步数据
export function syncComment(data) {
    return request._post('/shop/education.Vr/syncComment', data);
}

// vr-同步数据
export function syncSign(data) {
    return request._post('/shop/education.Vr/syncSign', data);
}

// vr-删除
export function CSdelete(data) {
    return request._post('/shop/education.Vr/CSdelete', data);
}


// video-列表
export function videoList(data) {
    return request._post('/shop/education.Video/index', data);
}
// video-详情
export function videoDetail(data) {
    return request._post('/shop/education.Video/detail', data);
}
// video-添加编辑
export function videoEdit(data) {
    return request._post('/shop/education.Video/edit', data);
}
// video-删除
export function videoDel(data) {
    return request._post('/shop/education.Video/del', data);
}

// video-列表
export function noticeList(data) {
    return request._post('/shop/education.Notice/index', data);
}
// video-详情
export function noticeDetail(data) {
    return request._post('/shop/education.Notice/detail', data);
}
// video-添加编辑
export function noticeEdit(data) {
    return request._post('/shop/education.Notice/edit', data);
}
// video-删除
export function noticeDel(data) {
    return request._post('/shop/education.Notice/del', data);
}



// ------------------------审核----------------------------
// 审核-提交
export function auditEdit(data) {
    return request._post('/shop/education.Audit/edit', data);
}
// 审核-详情
export function auditDetail(data) {
    return request._post('/shop/education.Audit/detail', data);
}

// ------------------------设置----------------------------
// 设置-获取
export function getSetting(data) {
    return request._post('/shop/education.Setting/getSetting', data);
}
// 设置-新增修改
export function setSetting(data) {
    return request._post('/shop/education.Setting/setSetting', data);
}

// ------------------------统计----------------------------
// 统计-男女比例统计
export function getGender(data) {
    return request._post('/shop/education.Statistics/getGender', data);
}
// 统计-年龄分布统计
export function getAge(data) {
    return request._post('/shop/education.Statistics/getAge', data);
}
// 统计-城市分布统计
export function getUserProvince(data) {
    return request._post('/shop/education.Statistics/getUserProvince', data);
}
// 统计-学习人数统计
export function getStudyNum(data) {
    return request._post('/shop/index/studyNum', data);
}

// ------------------------积分----------------------------
// 积分-积分兑换记录
export function pointList(data) {
    return request._post('/shop/education.Point/index', data);
}
// 积分-审核积分兑换现金
export function pointAudit(data) {
    return request._post('/shop/education.Point/audit', data);
}
// 积分-积分兑换学分记录
export function pointCreditList(data) {
    return request._post('/shop/education.Point/pointCreditList', data);
}

// ------------------------示范点位----------------------------
// 示范点位-保存
export function demoSiteSave(data) {
    return request._post('/shop/education.DemoSite/saveData', data);
}
// 示范点位-列表
export function demoSiteList(data) {
    return request._post('/shop/education.DemoSite/getList', data);
}
// 示范点位-详情
export function demoSiteDetail(data) {
    return request._post('/shop/education.DemoSite/detail', data);
}
// 示范点位-删除
export function demoSiteDel(data) {
    return request._post('/shop/education.DemoSite/delete', data);
}

// ------------------------创建动态----------------------------
//创建动态-保存
export function dynamicSave(data) {
    return request._post('/shop/education.Dynamic/saveData', data);
}
// 创建动态-列表
export function dynamicList(data) {
    return request._post('/shop/education.Dynamic/getList', data);
}
// 创建动态-详情
export function dynamicDetail(data) {
    return request._post('/shop/education.Dynamic/detail', data);
}
// 创建动态-删除
export function dynamicDel(data) {
    return request._post('/shop/education.Dynamic/delete', data);
}

// ------------------------小程序公告----------------------------
//创建动态-保存
export function appNoticeSave(data) {
    return request._post('/shop/education.AppNotice/saveData', data);
}
// 创建动态-列表
export function appNoticeList(data) {
    return request._post('/shop/education.AppNotice/getList', data);
}
// 创建动态-详情
export function appNoticeDetail(data) {
    return request._post('/shop/education.AppNotice/detail', data);
}
// 创建动态-删除
export function appNoticeDel(data) {
    return request._post('/shop/education.AppNotice/delete', data);
}





// WEBPACK FOOTER //
// ./src/api/education.js